export enum JourneyStepsEnum {
    ServiceDetailsStep = 1,
    InitialDetailsStep = 2,
    AppointmentPickerStep = 3,
    CustomerDetailsStep = 4,
    PaymentStep = 5,
    AppointmentConfirmed = 6
}